import _asyncToGenerator from "@babel/runtime/helpers/esm/asyncToGenerator";
import "regenerator-runtime/runtime.js";
import { defineComponent } from 'vue';
import ConsultationSection from '@/shared/ui/landing/ConsultationSection.vue';
import { LandingHeroSection, LandingOfferSection, LandingPartnersSection, LandingSellOnlineSection, LandingSignUpSection, useMainPageTemplates } from '@/widgets/landing';
export default defineComponent({
  name: 'IndexPage',
  components: {
    ConsultationSection: ConsultationSection,
    LandingHeroSection: LandingHeroSection,
    LandingOfferSection: LandingOfferSection,
    LandingPartnersSection: LandingPartnersSection,
    LandingSellOnlineSection: LandingSellOnlineSection,
    LandingSignUpSection: LandingSignUpSection
  },
  layout: 'LayoutLanding',
  middleware: ['mainPageRedirect'],
  setup: function setup() {
    var _useMainPageTemplates = useMainPageTemplates(),
      content = _useMainPageTemplates.content,
      manager = _useMainPageTemplates.manager,
      sections = _useMainPageTemplates.sections,
      fetchMainPageData = _useMainPageTemplates.fetchMainPageData;
    return {
      content: content,
      manager: manager,
      sections: sections,
      fetchMainPageData: fetchMainPageData
    };
  },
  fetch: function fetch() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function (_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.next = 1;
            return _this.fetchMainPageData();
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }))();
  },
  head: function head() {
    var pageTitle = this.$t('pageTitle');
    var pageDescription = this.$t('pageDescription');
    return {
      title: pageTitle,
      meta: [{
        hid: 'og:title',
        property: 'og:title',
        content: pageTitle
      }, {
        hid: 'og:description',
        property: 'og:description',
        content: pageDescription
      }, {
        hid: 'description',
        name: 'description',
        content: pageDescription
      }, {
        hid: 'robots',
        name: 'robots',
        content: 'index'
      }]
    };
  }
});